import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.96vw"
        },
        card: {
            width: "100%",
            height: "120vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "1.25vw"
        },
        card: {
            width: "100%",
            height: "28.13vw",
            backgroundColor: Color.White
        }
    }
};

export const ApplicationPopUpLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="3%" rx="3" ry="3" width="30%" height="6%"/>
                        <rect x="0%" y="14.3%" rx="3" ry="3" width="49%" height="5.25%"/>
                        <rect x="0%" y="22.45%" rx="3" ry="3" width="100%" height="28.25%"/>
                        <rect x="0%" y="56.45%" rx="3" ry="3" width="100%" height="12.45%"/>
                        <rect x="0%" y="73.45%" rx="3" ry="3" width="100%" height="12.45%"/>
                        <rect x="0%" y="90.45%" rx="3" ry="3" width="100%" height="12.45%"/>
                    </> :
                    <>
                        <rect x="0%" y="3.71%" rx="3" ry="3" width="30%" height="7.23%"/>
                        <rect x="0%" y="14.42%" rx="3" ry="3" width="56%" height="5.22%"/>
                        <rect x="0%" y="24.30%" rx="3" ry="3" width="100%" height="23.61%"/>
                        <rect x="0%" y="52.76%" rx="3" ry="3" width="100%" height="16.15%"/>
                        <rect x="0%" y="73.22%" rx="3" ry="3" width="100%" height="16.15%"/>
                        <rect x="0%" y="93.68%" rx="3" ry="3" width="100%" height="16.15%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}